const galleryId = 36;

const items = [];

let id = galleryId * 1000;

function addItemToGroup(item, tag) {
    id++;
    items.push({
        "id": id,
        "title": { "en": "" },
        "src": item,
        "tags": [tag],
        "groups": [galleryId],
        "ordering": id,
    });
}
let group = [];

group = ["sh_1498595621.jpg","sh_1797489829.jpg","sh_1823435843.jpg","sh_95473189.jpg","sh_1249688377.jpg","sh_1797489835.jpg","sh_1797489838.jpg"];
group.forEach((i) => addItemToGroup(i, '1. Inlay'));

group = ["sh_1457528462.jpg","sh_1646434096.jpg","sh_1254136237.jpg","sh_1537207223.jpg","sh_1792459216.jpg","sh_1368270188.jpg","sh_1570562698.jpg","sh_1570562677.jpg"];
group.forEach((i) => addItemToGroup(i, '2. Onlay'));

group = ["sh_1735148612.jpg","sh_166386377.jpg"];
group.forEach((i) => addItemToGroup(i, 'Before-after'));

group = ["sh_25133566.jpg","sh_1498595603.jpg","sh_25133569.jpg","sh_795144658.jpg","sh_1382843852.jpg"];
group.forEach((i) => addItemToGroup(i, 'deleted'));

export default items;
